




































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import API from '@/Api';
import { url } from 'inspector';
const namespace: string = 'AppStore';

@Component
export default class ImageGallery extends Vue {
  @Getter('role', { namespace }) public userRole: any;
  public idx: number = 0;
  public items: any = null;
  public select: boolean = false;
  public data: string = '';
  public urls: string[] = [
    'https://sulekhaportal.blob.core.windows.net/assets/logo.png'];
  public url: string = this.urls[this.idx];
  public mounted() {
    window.setInterval(() => {
        this.idx += 1;
        if (this.idx === this.urls.length) {
          this.idx = 0;
        }
        this.url = this.urls[this.idx];
    }, 5000);
    this.load();
  }
  public load() {
    const that = this;
    let imgSrc = [{}];
    const srv = '';
    API.Instance
    .get('/api/upload-image/getImage')
    .then((response) => {
      imgSrc = response.data;
      imgSrc.forEach((element) => {
       that.items = element;
       this.urls.push(that.items.url);
       that.data = that.items.eventName;
     });
    });
  }
}
